import { atom } from "recoil";

const RouteParamsAtom = atom({
  key: "@route_params",
  default: <RouteParamsAtomT>{},
});

export default RouteParamsAtom;
